import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { API_BASE_URL } from './services/direct-depositAPI.service';
import { AppRoutingModule } from './app-routing.module';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { environment } from '../environments/environment';
import { WcbLoggingJS } from './services/wcbLogging';
import { AppComponent } from './app.component';

import {
  WsbcBusyIndicatorModule,
  WsbcModalDialogModule,
  WsbcTemplateModule
} from '@wsbc/ux-lib';
import { ModalModule } from 'ngx-bootstrap/modal';
import { BankingInfoComponent } from './components/direct-deposit/banking-info.component';
import { ConfirmationComponent } from './components/confirmation/confirmation.component';
import { WsbcTopNavbarCustomComponent } from './components/wsbc-top-navbar/wsbc-top-navbar-custom.component';
import { ReactiveFormsModule } from '@angular/forms';

import { NgxMaskModule } from 'ngx-mask';
import { BankingUpdateComponent } from './components/banking-update/banking-update.component';
import { DatePipe } from '@angular/common';
import { IdamTokenService } from './services/idam-token-service';
import { BankingCancelComponent } from './components/banking-cancel/banking-cancel.component';
import { AuthService, IdamAuthenticationGuard, IdamAuthService, SECURITY_SETTINGS, TokenInterceptor } from '@wsbc/ux-lib-security';
import { BankingErrorComponent } from './components/banking-error/banking-error.component';
import { SurveybarComponent } from './components/surveybar/surveybar.component';


export function initApp(authService: AuthService) {
  return () => authService.initialize();
}


@NgModule({ declarations: [
        AppComponent,
        BankingInfoComponent,
        ConfirmationComponent,
        BankingUpdateComponent,
        WsbcTopNavbarCustomComponent,
        BankingCancelComponent,
        BankingErrorComponent,
        SurveybarComponent
    ],
    bootstrap: [AppComponent], imports: [AppRoutingModule,
        BrowserModule,
        ReactiveFormsModule,
        // MsAdalAngular6Module.forRoot(environment.security),
        WsbcModalDialogModule,
        ModalModule.forRoot(),
        WsbcBusyIndicatorModule,
        WsbcTemplateModule,
        NgxMaskModule.forRoot()], providers: [
        IdamAuthService,
        IdamAuthenticationGuard,
        // AdalAuthenticationGuard,
        IdamTokenService,
        DatePipe,
        {
            provide: APP_INITIALIZER,
            useFactory: initApp,
            multi: true,
            deps: [environment.security.authService]
        },
        {
            provide: SECURITY_SETTINGS,
            useValue: environment.security
        },
        {
            provide: API_BASE_URL,
            useValue: environment.directDepositBaseUrl
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: TokenInterceptor,
            multi: true
        },
        {
            provide: AuthService,
            useExisting: environment.security.authService
        },
        WcbLoggingJS,
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class AppModule { }
